// ─── Маршруты ────────────────────────────────────────────────
export const ROUTES = {
  LOGIN: '/login',
  HOME: '/',
  REPORT: '/report',
  DATA: '/data',
  EQUIPMENT: '/equipment',
  PROFILE: '/profile',
}

// ─── Периоды графиков ────────────────────────────────────────
export const CHART_PERIODS = [
  { label: '24ч', value: '24h' },
  { label: '7д',  value: '7d' },
  { label: '30д', value: '30d' },
  { label: '90д', value: '90d' },
  { label: 'Год', value: '1y' },
]

// ─── Статусы оборудования ────────────────────────────────────
export const EQUIPMENT_STATUS = {
  online:      { label: 'Онлайн',        badgeClass: 'bg-success' },
  offline:     { label: 'Оффлайн',       badgeClass: 'bg-danger' },
  error:       { label: 'Ошибка',        badgeClass: 'bg-warning' },
  maintenance: { label: 'Обслуживание',  badgeClass: 'bg-info' },
  unknown:     { label: 'Неизвестно',    badgeClass: 'bg-secondary' },
}

// ─── Ключи localStorage ──────────────────────────────────────
export const STORAGE_KEYS = {
  USER:             'user',
  MANUAL_ROW_ORDER: 'sourceData.manualRowOrder',
  SELECTED_CITY:    'selectedCityId',
}

// ─── Часов в сутках ──────────────────────────────────────────
export const HOURS_IN_DAY = 24

// ─── Карта: fallback-значения ─────────────────────────────────
export const DEFAULT_MAP_CENTER = [55.75, 37.61]
export const DEFAULT_MAP_ZOOM = 12
